// Task #2327 — Helper di presentazione per gli strumenti usati dall'agente PA
// nel flusso chat (stile Claude): riconoscimento dei tool di ricerca/scraping
// web, così l'indicatore "Cerco sul web…" è distinto dai badge tool generici.

/** Pattern che identificano un tool come ricerca/scraping sul web. */
const WEB_SEARCH_RE = /(web_search|firecrawl|tavily|serper|brave_search|google_search|url_context|scrape|crawl|websearch)/i;

/** True se il tool è una ricerca/scraping sul web (nativo o MCP). */
export function isWebSearchTool(rawName: string): boolean {
  return WEB_SEARCH_RE.test(rawName || '');
}
